import useSWR from 'swr';
import { fetchData } from '../../../../lib/dashboard/data';
import MarketMoneyFlow from './MarketMoneyFlow';

const MarketMonkeyFlowContainer = () => {
    const {
        data: tableData = { data: [], title: "", cols: {} },
        isLoading,
    } = useSWR("/dashboard/market-money-flow", fetchData, {
        revalidateOnFocus: false,
        dedupingInterval: 60 * 1000,
    });

    return (
        <MarketMoneyFlow tableData={tableData} isLoading={isLoading} />
    )
}

export default MarketMonkeyFlowContainer